<template>
  <div class="cs-compare">
    <!-- Label and value columns line up so the invalid code sits directly under the one shown above it. -->
    <div class="cs-compare-grid">
      <strong class="cs-compare-label">Charge String Code :</strong>
      <span class="cs-compare-value">{{ current }}</span>
      <small class="cs-compare-note"><slot name="current-note" /></small>
      <template v-if="overflow">
        <strong class="cs-compare-label cs-compare-invalid">{{ invalidLabel }} :</strong>
        <span class="cs-compare-value cs-compare-invalid">{{ overflowHead }}<span class="cs-compare-extra" title="Extra digits that don't fit">{{ overflow.dropped }}</span></span>
        <small class="cs-compare-note cs-compare-invalid">{{ overflow.digits.length }} digits</small>
      </template>
    </div>
    <!-- Page-specific explanation, shown only while there is something to compare. -->
    <div v-if="overflow && $scopedSlots.default" class="cs-compare-error" role="alert">
      <slot :overflow="overflow" />
    </div>
  </div>
</template>

<script>
import { splitChargeString, chargeStringOverflow } from './chargeString';

export default {
  name: 'ChargeStringCompare',
  props: {
    // The code as the sections show it, already formatted (e.g. 370-31240-...).
    current: { type: String, default: '' },
    // The too-long code to compare against, digits only. Nothing is shown for a code that fits.
    invalid: { type: String, default: '' },
    invalidLabel: { type: String, default: 'Saved code (invalid)' },
  },

  computed: {
    overflow() {
      return chargeStringOverflow(this.invalid);
    },
    // Split into the same sections as `current`; the extra digits are rendered after it.
    overflowHead() {
      return this.overflow ? splitChargeString(this.overflow.digits).join('-') : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-compare {
  font-size: 12px;
  color: #5e5873;
  text-align: left;
}

.cs-compare-grid {
  display: grid;
  grid-template-columns: max-content max-content auto;
  column-gap: 8px;
  row-gap: 2px;
  align-items: baseline;
}

.cs-compare-error {
  margin-top: 8px;
  padding: 8px 10px;
  max-width: 560px;
  border: 1px solid rgba(234, 84, 85, 0.4);
  border-left: 3px solid #ea5455;
  border-radius: 5px;
  background: rgba(234, 84, 85, 0.08);
  color: #b3393a;
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  line-height: 1.5;
}

.cs-compare-label {
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  text-align: right;
}

.cs-compare-value {
  font-family: SFMono-Regular, Menlo, Consolas, monospace;
  white-space: nowrap;
}

.cs-compare-note {
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  font-size: 11px;
}

.cs-compare-invalid {
  color: #b3393a;
}

.cs-compare-extra {
  font-weight: 700;
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 2px;
}
</style>
